export const isEmail = (email) => {
  const re =
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return re.test(email);
};

export const isPhoneNumber = (phoneNumber) => {
  const onlyDigits = phoneNumber.replace(/\D+/g, "");
  return onlyDigits.length === 10;
};

/**
 * Checks for valid fees, so negates undefined, null, '', NaNs etc
 * @param {string | number} value 
 * @returns 
 */
export function isValidFees(value) {
  const num = Number(value);
  return (
    value !== undefined &&
    value !== null &&
    value !== '' &&
    !isNaN(num) 
  );
}

/**
 * 
 * @param {number} p Portfolio Fees if overriden
 * @param {number} a Advisor's own fee rate
 * @param {number} ad Default advisor fee rate by CY
 */
export function getValidAdvisorFees(p, a, ad) {
  let fee = 0;

  if (isValidFees(p)) {
    fee = p;
  } else if (isValidFees(a)) {
    fee = a;
  } else if (isValidFees(ad)) {
    fee = ad;
  }

  return fee;
}


// WEBPACK FOOTER //
// ./src/utilities/validators.js